import { createArray } from 'utils/helpers/create-fake-array';
import { ADVANCED_SKELETON_COUNTS } from 'newelements/Sportsbook/layouts/advanced/constants/skeleton-counts';
import { MatchCardInlineSkeleton } from 'components/MatchCardInline/Skeleton';
import { NavigationCollapse } from 'components/NavigationCollapse';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const AdvancedLiveGamesListSkeleton = () => {
  return (
    <div className="advancedLiveGamesListWrapper">
      {createArray(ADVANCED_SKELETON_COUNTS._4).map(item => (
        <NavigationCollapse
          key={item}
          defaultActive={item === 0}
          headerClassName="liveSportCollapseHeader"
          wrapperClassName="liveSportCollapseWrapper"
          icon={
            <Skeleton.Button
              active
              shape="round"
              style={{ minWidth: 24, width: 24, height: 24 }}
            />
          }
          title={<Skeleton.Button active style={{ width: 80, height: 24 }} />}
        >
          <LiveCompetitionsCollapseSkeleton />
        </NavigationCollapse>
      ))}
    </div>
  );
};

export const LiveCompetitionsCollapseSkeleton = () => {
  return (
    <NavigationCollapse
      key={0}
      defaultActive
      headerClassName="liveRegionCollapseHeader"
      wrapperClassName="liveRegionCollapseWrapper"
      icon={
        <Skeleton.Button
          active
          shape="round"
          style={{ minWidth: 24, width: 24, height: 24 }}
        />
      }
      title={<Skeleton.Button active style={{ width: 80, height: 24 }} />}
    >
      {createArray(ADVANCED_SKELETON_COUNTS._4).map(item => (
        <MatchCardInlineSkeleton key={item} />
      ))}
    </NavigationCollapse>
  );
};
